import React, { useEffect, useRef, useState } from 'react';
import { registrosApi } from '../../../api/registrosApi';

export default function InventarioPinModal({
  abierto,
  titulo = 'Confirmar operación',
  descripcion = 'Identificá al usuario que realiza la operación',
  etiquetaPin = 'PIN del usuario',
  procesando = false,
  onClose,
  onConfirm,
}) {
  const inputRef = useRef(null);
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!abierto) return;

    setPin('');
    setError('');

    requestAnimationFrame(() => {
      inputRef.current?.focus();
    });
  }, [abierto]);

  if (!abierto) return null;

  const confirmar = async (event) => {
    event.preventDefault();

    const pinLimpio = pin.trim();

    if (!pinLimpio) {
      setError('Ingresá el PIN del usuario.');
      inputRef.current?.focus();
      return;
    }

    try {
      setError('');

      const response = await registrosApi.verifyPassword({
        password: pinLimpio,
      });

      if (!response?.data?.esValida || !response?.data?.usuario?.id) {
        setError('PIN incorrecto.');
        setPin('');

        requestAnimationFrame(() => {
          inputRef.current?.focus();
        });

        return;
      }

      // El PIN viaja como segundo argumento para las operaciones que el
      // backend autoriza por su cuenta (por ejemplo, el ajuste de stock).
      await onConfirm(response.data.usuario, pinLimpio);
    } catch (err) {
      console.error('Error validando PIN de inventario:', err);

      setError(
        err?.response?.data?.error ||
          err?.message ||
          'No se pudo validar el PIN.'
      );

      requestAnimationFrame(() => {
        inputRef.current?.focus();
      });
    }
  };

  return (
    <div className="fixed inset-0 z-[120] grid place-items-center bg-black/75 p-4 backdrop-blur-sm">
      <form
        onSubmit={confirmar}
        className="w-full max-w-sm overflow-hidden rounded-2xl border border-blanco-puro/20 bg-gradient-to-br from-azul-oscuro to-azul-lago text-blanco-puro shadow-2xl"
      >
        <div className="border-b border-blanco-puro/15 px-6 py-5 text-center">
          <div className="text-xs font-bold uppercase tracking-[0.18em] text-amarillo-dorado">
            Driza Camp · Seguridad
          </div>

          <h2 className="mt-2 text-xl font-bold">
            {titulo}
          </h2>

          <p className="mt-1 text-sm text-blanco-puro/60">
            {descripcion}
          </p>
        </div>

        <div className="p-6">
          <label className="block">
            <span className="mb-2 block text-xs font-bold uppercase tracking-wide text-amarillo-dorado">
              {etiquetaPin}
            </span>

            <input
              ref={inputRef}
              name="cantina-inventory-pin"
              type="password"
              autoComplete="one-time-code"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck={false}
              data-lpignore="true"
              data-1p-ignore="true"
              value={pin}
              onChange={(event) => setPin(event.target.value)}
              disabled={procesando}
              className="h-12 w-full rounded-xl border border-blanco-puro/20 bg-azul-oscuro/70 px-4 text-center text-xl font-bold tracking-[0.25em] text-blanco-puro outline-none transition focus:border-amarillo-dorado focus:ring-2 focus:ring-amarillo-dorado/40 disabled:opacity-50"
            />
          </label>

          {error && (
            <div className="mt-4 rounded-xl border border-red-300/30 bg-red-500/20 px-3 py-2 text-center text-sm text-red-100">
              {error}
            </div>
          )}

          <div className="mt-6 flex gap-3">
            <button
              type="button"
              onClick={onClose}
              disabled={procesando}
              className="flex-1 rounded-xl border border-blanco-puro/30 bg-blanco-puro/5 px-4 py-2.5 text-sm font-semibold text-blanco-puro transition hover:bg-blanco-puro/10 disabled:opacity-50"
            >
              Cancelar
            </button>

            <button
              type="submit"
              disabled={procesando}
              className="flex-1 rounded-xl bg-amarillo-dorado px-4 py-2.5 text-sm font-bold text-azul-oscuro shadow-lg transition hover:bg-amber-400 disabled:opacity-50"
            >
              {procesando ? 'Guardando...' : 'Confirmar'}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
